<div class="content" id="content" >
  <div class="content-search">
    <h1>物流商务诚信信息查询</h1>
    <div class="top-search">
      <input [(ngModel)]="keyWord" type="text" class="search" placeholder="请输入关键字搜索"
        (keyup)="inputSomething($event)">
      <span class="right-search-btn clear icon-search" [routerLink]="['/searchParent']"
            [queryParams]="{userId: userId, userName: userName, keyWord: keyWord, fromType: '1'}"></span>
    </div>
  </div>

  <table class="content-list">
    <tr>
      <td>
        <a [routerLink]="['/enterpNewsInfo']" [queryParams]="{userId: userId, userName: userName, fromType: '1'}">
          <img src="../../../assets/images/gz/ecommerce/ecommerce (1).png">
        </a>
      </td>
      <td>
        <a href="http://gdintegrity.credit100.com/data-analysis/data.html">
          <img src="../../../assets/images/gz/ecommerce/ecommerce (2).png">
        </a>
      </td>
      <td>
        <a [routerLink]="['/searchParent']" [queryParams]="{userId: userId, userName: userName, fromType: '1'}">
          <img src="../../../assets/images/gz/ecommerce/ecommerce (3).png">
        </a>
      </td>
      <td>
        <a [routerLink]="['/enterpAtlas']" [queryParams]="{userId: userId, userName: userName, fromType: '1'}">
          <img src="../../../assets/images/gz/ecommerce/ecommerce (4).png">
        </a>
      </td>
      <td>
        <a [routerLink]="['/enterpEmployees']" [queryParams]="{userId: userId, userName: userName, fromType: '1'}">
          <img src="../../../assets/images/gz/ecommerce/ecommerce (5).png">
        </a>
      </td>
      <td>
        <a [routerLink]="['/information']" [queryParams]="{userId: userId, userName: userName, fromType: '1'}">
          <img src="../../../assets/images/gz/ecommerce/ecommerce (6).png">
        </a>
      </td>
    </tr>
  </table>

</div>





// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/gz-logistics-search/gz-logistics-search.component.html